import React from "react";
import "../../../index.css";
import BannerImage from "../../../helper/images/About-banner.png";
import { Link } from "react-router-dom";
import { useTranslation } from "../../../hooks/useTranslation";
const BannerSection = () => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className="lg:py-[118px] md:py-[70px] py-[30px]"
        style={{
          backgroundImage: "url(" + BannerImage + ")",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="text-center text-white">
            <h2 className="lg:text-[40px] md:text-[30px] text-[25px] font-semibold lg:leading-[50px] mb-[20px]">
              {t("about").banner.title}
            </h2>
            <p className="text-lg ">{t("about").banner.subtitle}</p>
            <Link
              to="/register"
              className="inline-block w-full sm:max-w-[184px]  rounded-[2px] bg-[#FFA808] 2xl:text-[20px] text-base text-white text-center font-bold 2xl:p-[14px] p-3 yellow-shadow hover:bg-[#D69723] mt-[30px]"
            >
              {t("about").banner.cta}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerSection;
